module.exports = __webpack_public_path__ + "media/images/riders/KATHRIN_STIRNEMANN-88818f07193d1303cb2891db5b6ef32e.png";